import { connect } from 'react-redux';
import Content, { Props } from '../components/Content';
import { portfolioNameSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import { hasAccessTokenSelector } from '@auth/redux/selectors';
import { hasLimitedCompanyViews, isUserTrialing } from '@user/redux/selectors';
import { getRegistrationFromNewsCookie } from '@/utilities/cookies';

const mapStateToProps = () => {
  return (state): Props => {
    const currentUrl = state.location ? state.location.type : '';
    const currentPortfolioName = portfolioNameSelector(state);
    const hasAccessToken = hasAccessTokenSelector(state);
    const getIsRegistrationFromNews = (): boolean => {
      return hasAccessToken && getRegistrationFromNewsCookie();
    };
    const route =
      (state.location &&
        state.location.routesMap &&
        state.location.routesMap[state.location.type]) ||
      void 0;
    const isRegistrationFromNews = getIsRegistrationFromNews();
    const hasLimitedCompanyReports =
      hasAccessToken && hasLimitedCompanyViews(state);

    return {
      hasLimitedCompanyReports,
      isTrialing: isUserTrialing(state),
      currentPortfolioName,
      currentUrl,
      hasSnackbarNotification: state.snackBar.keys.length > 0,
      isAuthenticated: hasAccessToken,
      layout: (route && route.layout) || void 0,
      isRegistrationFromNews,
    };
  };
};

export default connect(mapStateToProps)(Content);
